import { BASE_CONTEMT_HEIGHT, BASE_CONTEMT_WIDTH, BASE_PADDING } from "./constants";

export const getPaddingByContent = (contentWidth: number, contentHeight: number) => {
    if (contentWidth > contentHeight) {
        return contentHeight * (BASE_PADDING / BASE_CONTEMT_HEIGHT);
    } else {
        return contentWidth * (BASE_PADDING / BASE_CONTEMT_WIDTH);
    }
};
